import styled from 'styled-components/macro'

export const ExpandableGridContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 12px 0 12px 24px;
`
